/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
// import axios from "axios";
import { axiosInstance } from "../utils/axiosInstance";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import FacebookLoginn from "./FacebookLogin";
import GoogleSignIn from "./GoogleSignIn";
import { useState } from "react";

function SignUpForm() {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const Navigate = useNavigate();
  // Validation schema for form fields
  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    password: Yup.string().required("Password is required"),
    password_confirmation: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Confirmation Password is required"),
    phone: Yup.string().required("Phone Number is required"),
  });

  // Initial form values
  const initialValues = {
    email: "",
    password: "",
    password_confirmation: "",
    phone: "",
  };

  // Handle form submission
  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const response = await axiosInstance.post("user/register", values);
      if (response?.data?.status == true) {
        toast.success("SignUp successfully");
        Navigate("/signin");
        localStorage.setItem("user", response?.data?.user);
      }
      // Handle success logic here (e.g., redirect, show message)
    } catch (error) {
      const { message } = error?.response?.data;
      toast.error(message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="container" style={{ height: "100vh" }}>
      <div className="row align-items-center h-100">
        <div className="col-lg-5 col-md-6">
          <img
            src="/images/signUpImg.png"
            className="img-fluid d-block my-auto"
            alt="Login Illustration"
          />
        </div>
        <div className="col-lg-6 col-md-6 ms-auto">
          <img
            src="/images/registerLogo.png"
            className="w-25 d-block mx-auto pb-4"
            alt="Register Logo"
          />
          <h1 className="fw-bolder text-black fs-2 py-2">Sign Up</h1>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form>
                <label className="fw-bolder text-secondary fs-6 pt-1">
                  Email Address
                </label>
                <Field
                  type="email"
                  name="email"
                  className="form-control border-2 border-secondary py-2 fw-semibold"
                  placeholder="hello@example.com"
                />
                <ErrorMessage
                  name="email"
                  component="div"
                  className="text-danger"
                />

                <label className="fw-bolder text-secondary fs-6 pt-3">
                  Phone
                </label>
                <Field
                  type="number"
                  name="phone"
                  className="form-control border-2 border-secondary py-2 fw-semibold"
                  placeholder="Phone"
                />
                <ErrorMessage
                  name="phone"
                  component="div"
                  className="text-danger"
                />

                <label className="fw-bolder text-secondary fs-6 pt-3">
                  Password
                </label>
                <div className="position-relative">
                  <Field
                    type={showPassword ? "text" : "password"}
                    name="password"
                    className="form-control border-2 border-secondary py-2 fw-semibold pe-5"
                    placeholder="Password"
                  />
                  <button
                    type="button"
                    className="btn btn-link position-absolute end-0 top-50 translate-middle-y me-2"
                    onClick={() => setShowPassword(!showPassword)}
                    style={{ color: "#6c757d" }}
                  >
                    <i
                      className={`fas fa-eye${showPassword ? "-slash" : ""}`}
                    />
                  </button>
                </div>
                <ErrorMessage
                  name="password"
                  component="div"
                  className="text-danger"
                />

                <label className="fw-bolder text-secondary fs-6 pt-3">
                  Password Confirmation
                </label>
                <div className="position-relative">
                  <Field
                    type={showConfirmPassword ? "text" : "password"}
                    name="password_confirmation"
                    className="form-control border-2 border-secondary py-2 fw-semibold pe-5"
                    placeholder="Confirm Password"
                  />
                  <button
                    type="button"
                    className="btn btn-link position-absolute end-0 top-50 translate-middle-y me-2"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    style={{ color: "#6c757d" }}
                  >
                    <i
                      className={`fas fa-eye${
                        showConfirmPassword ? "-slash" : ""
                      }`}
                    />
                  </button>
                </div>
                <ErrorMessage
                  name="password_confirmation"
                  component="div"
                  className="text-danger"
                />

                <div className="d-flex gap-2 pt-2 align-items-center">
                  <input
                    className="form-check-input border-3 px-2 py-2 border-secondary"
                    type="checkbox"
                  />
                  <label className="form-check-label fw-bold text-secondary">
                    Remember my preference
                  </label>
                </div>

                {/* <p className="d-flex gap-2 pt-1 mb-0">
                  <a href="#" className="text-decoration-none">
                    Forgot Password?
                  </a>
                </p> */}

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="btn btn-danger w-100 fw-bold py-2 fs-6"
                  style={{ background: "#CD2128", border: "none" }}
                >
                  {isSubmitting ? "Signing In..." : "Sign Up"}
                </button>
              </Form>
            )}
          </Formik>
          {/* Social Login and Additional Links */}
          <div className="d-flex gap-2 align-items-center justify-content-center py-3">
            <div
              style={{
                padding: "2px 0px",
                width: "10%",
                background: "#EEEEEE",
              }}
            />
            <p className="text-center m-0 text-secondary">Continue With</p>
            <div
              style={{
                padding: "2px 0px",
                width: "10%",
                background: "#EEEEEE",
              }}
            />
          </div>
          <div className="d-flex flex-wrap gap-2 align-items-center justify-content-center py-3">
            <FacebookLoginn />

            <GoogleSignIn />
          </div>
          <Link
            to={"/signin"}
            className="btn btn-link text-secondary text-center d-block text-decoration-none"
          >
            Already Have An Account?{" "}
            <span className="text-danger">Sign In</span>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default SignUpForm;
